import {QuestionnairePopupComponent} from './../../questionnaire-popup/questionnaire-popup.component';
import {LanguageService} from './../../services/language.service';
import {Component, Input, OnDestroy, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {forEach} from "@angular/router/src/utils/collection";
import {TranslateService} from "@ngx-translate/core";
import {ToasterConfig} from "angular2-toaster";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {Observable} from 'rxjs/Rx';
import {Subject} from 'rxjs/Subject';
import {QhseInformationModalComponent} from "../../qhse-information-modal/qhse-information-modal.component";
import {CommunicationLogPdfViewerComponent} from "../../communication-log-pdf-viewer/communication-log-pdf-viewer.component";
import {AuthenticationService} from '../../services/authentication.service';
import {Globals} from "../../services/globals";
import {HelperService} from '../../services/helper.service';
import {TosterMessageService} from "../../services/toster-message.service";
import {AppResetPasswordComponent} from "../app-reset-password/app-reset-password.component";
import {QuestionnaireService} from 'app/services/questionnaire.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  providers: [AuthenticationService, TosterMessageService, TranslateService, QuestionnaireService]
})
export class AppHeaderComponent implements OnDestroy {

  profile: any = {};
  profilePic: string = 'profileImage/default.png';
  private totalpendingApproval: number;
  bsModalRefCorrectiveAction: BsModalRef;
  public now: Date = new Date();
  isPosTerminal: number = 1;
  @Input('outlet') outletName;
  @Input('companyName') companyName;
  @Input('companyCode') companyCode;
  @ViewChild('swalModalPageNotAccess') swalModalPageNotAccess: any;
  countDown: any;
  navSelected: string;
  navMenus: any[] = [];
  public companySystemID = +this.helperService.getSelectedCompanyId();
  public toasterconfig: ToasterConfig =
    new ToasterConfig({
      tapToDismiss: true,
      timeout: 5000
    });

  availableLang: any = [];
  communicationLogBullet: any = [];
  communicationLogSafety: any = [];
  selectedLang = 'en';
  selectedIcon = 'us';
  bsModalRefPrint: BsModalRef;
  bsModalRefQuestionnaire: BsModalRef;
  public helpDeskEmail: string;
  public helpDeskToken: string;

  constructor(private authenticationService: AuthenticationService,
              private route: ActivatedRoute,
              public translate: TranslateService,
              private helperService: HelperService,
              private modalService: BsModalService,
              public globals: Globals,
              private questionnaireService: QuestionnaireService,
              private tosterMessageService: TosterMessageService,
              private languageService: LanguageService) {
    this.totalpendingApproval = 0;
    if (this.helperService.getRouteDataByKey(this.route.snapshot, 'isPosTerminal')) {
      this.isPosTerminal = 1;
    } else {
      this.isPosTerminal = 0;
    }
    this.getCurrentUserInfo();
    if (this.isPosTerminal == 0) {
      this.countDown = Observable.interval(59000)
        .takeUntil(this.onDestroy$)
        .subscribe(x => {
          //this.getTotalCountOfApproval();
        });

      setTimeout(() => {
        //this.getTotalCountOfApproval();
      }, 5);
    }

    this.availableLang = this.helperService.getAvailableLang();
    translate.setDefaultLang('en');

    if (localStorage.getItem("lang")) {
      this.selectedLang = localStorage.getItem("lang");
    }
    this.translate.use(this.selectedLang);
    for (let i = 0; this.availableLang.length; i++) {
      if (this.selectedLang == this.availableLang[i].label) {
        this.selectedIcon = this.availableLang[i].icon;
        break;
      }
    }
    if (this.companySystemID == 4) {
      this.almahaCommunicationPopup();
    }

    this.questionnairePopUp();
  }

  getUserMenu() {
    const that = this;
    that.navMenus = [];
    that.authenticationService
      .getUserMenu()
      .get(
        {companyId: that.companySystemID}
      )
      .subscribe(resp => {
        that.navMenus = resp.data.data;
      }, (error) => {
      });
  }

  changeTypeaheadLoading(e: boolean): void {
  }

  navChanged(event) {
    if (event.item) {
      let params: any = {
        companyID: this.helperService.getSelectedCompanyId(),
        navigationMenuID: event.item.navigationMenuID
      };
      this.authenticationService
        .checkUserGroupAccessRights()
        .get(params)
        .subscribe(resp => {
          let data: any = resp.data.data;
          if (!data['R']) {
            //no access
            this.showNotAccessModal();
          } else {
            // redirect to page
            if (event.item.url) {
              this.helperService.go(event.item.url);
            }
          }
        }, (error) => {
          this.showNotAccessModal();
        });
    }
  }

  showNotAccessModal() {
    this.swalModalPageNotAccess.show();
  }

  onChangeLang(value) {
    localStorage.setItem("lang", value.label);
    this.translate.use(value.label);
    this.selectedLang = value.label;
    this.selectedIcon = value.icon;
    this.getUserMenu();
    this.languageService.languageChanged();
  }

  private onDestroy$ = new Subject<void>();

  public ngOnDestroy() {
    if (this.bsModalRefCorrectiveAction) {
      this.bsModalRefCorrectiveAction.hide();
    }
    this.onDestroy$.next();
  }

  logout() {
    this.authenticationService.logout();
  }

  getCurrentUserInfo() {
    var that = this;
    this.authenticationService.getCurrentUserInfo().get()
      .subscribe(resp => {
        that.profile = resp.data;
        that.getUserMenu();
        if (that.profile.company) {
          this.globals.theme = that.profile.company.themeColor;
          this.globals.themeFont = that.profile.company.themeFontColor;
          this.helpDeskToken = that.profile.company.helpDeskTokenKey;
        }
        that.helpDeskEmail = that.profile.empEmail;
        if (that.profile.profileImage) {
          that.profilePic = that.profile.profileImage;
        }
        setTimeout(() => {
          that.widgetHelpDesk();
        }, 0);

      }, (error) => {

      });
  }

  resetPassword() {
    this.bsModalRefCorrectiveAction = this.modalService.show(AppResetPasswordComponent, {
      class: 'modal-md',
      backdrop: 'static'
    });
  }

  public templateAssignedRouteView() {
    const that = this;
    that.authenticationService
      .getTemplateAssignedRoute()
      .get({
        crudType: 'Edit',
        documentSystemID: 9,
        companySystemID: that.helperService.getSelectedCompanyId()
      })
      .subscribe((output) => {
        const resp = output.data.data;
        let url = "configuration/profile";
        if (resp.templateDetailID == 220) {
          url = "configuration/profile-alkhoraye";
        }
        if (resp.templateDetailID == 224) {
          url = "configuration/profile-nesr";
        }
        this.helperService.go(url);
      }, () => {
      });
  }

  public goToProfile() {
    this.templateAssignedRouteView();
  }

  public goToActivityFeed() {
    this.helperService.go("recognition");
  }

  public goToApprovalDelegation() {
    this.helperService.go("configuration/approval-delegation");
  }

  public goToLeadershipBoard() {
    this.helperService.go("reports/leadership-board-report");
  }

  public goToInformation() {
    //this.helperService.go("dashboard/qhse-information");
    const that = this;
    that.bsModalRefPrint = that.modalService.show(QhseInformationModalComponent, {
      class: 'modal-lg',
      backdrop: 'static'
    });

  }

  public goToTrainingProgram() {
    this.helperService.go("training-program/user-training-programs");
  }

  public goToTraining() {
    this.helperService.go("training/training-list");
  }

  public goToAssignment() {
    this.helperService.go("training/assignment");
  }

  getTotalCountOfApproval() {
    let that = this;
    this.authenticationService
      .getTotalCountOfApproval().get()
      .subscribe(resp => {
        this.totalpendingApproval = resp.data.data;
      }, (error) => {
        this.totalpendingApproval = 0;
      });
  }

  public almahaCommunicationPopup() {
    const that = this;
    this.authenticationService
      .getCommunicationLogPDF().get()
      .subscribe(resp => {
        this.communicationLogBullet = resp.data.data.bulletinData;
        this.communicationLogSafety = resp.data.data.safetyAlertsData;
        if (this.communicationLogBullet) {
          that.bsModalRefPrint = that.modalService.show(CommunicationLogPdfViewerComponent, {
            class: 'modal-lg',
            backdrop: 'static'
          });
          that.bsModalRefPrint.content.masterData = this.communicationLogBullet;
          that.bsModalRefPrint.content.modelTitle = 'Bulletin';
        }
        if (this.communicationLogSafety) {
          that.bsModalRefPrint = that.modalService.show(CommunicationLogPdfViewerComponent, {
            class: 'modal-lg',
            backdrop: 'static'
          });
          that.bsModalRefPrint.content.masterData = this.communicationLogSafety;
          that.bsModalRefPrint.content.modelTitle = 'Safety Alert';
        }

      }, (error) => {
      });
  }

  public questionnairePopUp() {
    const that = this;
    this.questionnaireService
      .getAvialableQuestionaires()
      .get()
      .subscribe(resp => {
        const data = resp.data.data;
        if (data.quiz.length > 0 || data.survey.length > 0) {
          that.bsModalRefQuestionnaire = this.modalService.show(QuestionnairePopupComponent, {
            class: 'modal-lg',
            backdrop: 'static'
          });
          that.bsModalRefQuestionnaire.content.questionnaires = data.quiz;
          that.bsModalRefQuestionnaire.content.survey = data.survey;
        }
      }, (error) => {
        let message;
        if (error.status === 500) {
          message = error.data.message;
        } else {
          message = 'Error Occurred';
        }
        this.tosterMessageService.showError('Error', message);
      });
  }

  openAllApproval() {
    this.helperService.go('../all-document-approval');

  }

  public widgetHelpDesk() {
    ((d, tenant, token, email, productIid, js) => {
      const script = d.createElement("script");
      script.src = js;
      document.getElementsByTagName("body")[0].appendChild(script);
      const element = d.createElement("hds-iframe");
      element.setAttribute("tenant", tenant);
      element.setAttribute("email", email);
      element.setAttribute("token", token);
      element.setAttribute("product_id", productIid);
      document.getElementsByTagName("body")[0].appendChild(element);
    })(
      document,
      "pbs",
      this.helpDeskToken,
      this.helpDeskEmail,
      "7",
      "https://w.pbs.ghelp.gears-int.com/iframe/app.js",
    );
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/app-header/app-header.component.ts